$(document).ready(function() {
 //homepage testimonial slider  
   $('.testimonial-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg></div>',
     responsive: [
         
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    });
   //homepage testimonial slider video 
   $('.testimonial-video-slide').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: '<div class="slick-prev"><svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg></div>',


    });

     //collection page filter accordian

    $(document).on('click','ul#categories-cls li.nav--has-dropdown span.arrow', function (){
    if($(this).parent('li').hasClass('liactive')==false){
      $('ul#categories-cls li.nav--has-dropdown span.arrow').removeClass('active').siblings('ul').slideUp().parent('li').removeClass('liactive');
      $('ul#categories-cls li.nav--has-dropdown span.arrow').removeClass('active').siblings('ul').slideUp().parent('li').find('span').removeClass('active_subchild');
      $(this).addClass('active').siblings('ul').slideDown().parent('li').addClass('liactive');
      $(this).addClass('active').siblings('ul').slideDown().parent('li').find('span').addClass('active_subchild');
       $(this).html('<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.9999 6.67262C14.0004 6.50185 13.9675 6.33312 13.9034 6.17883C13.8394 6.02454 13.746 5.88861 13.63 5.78103L7.63053 0.260033C7.45162 0.0919093 7.22719 -9.28495e-08 6.99559 -8.9874e-08C6.76399 -8.68986e-08 6.53957 0.0919093 6.36065 0.260033L0.361218 5.97535C0.157021 6.16937 0.0286086 6.44818 0.00423118 6.75043C-0.0201462 7.05269 0.061508 7.35363 0.231231 7.58707C0.400953 7.8205 0.644841 7.9673 0.909243 7.99516C1.17364 8.02303 1.4369 7.92969 1.6411 7.73566L7.00059 2.62617L12.3601 7.5642C12.5069 7.70398 12.6856 7.79277 12.8751 7.82007C13.0646 7.84736 13.257 7.81202 13.4296 7.71823C13.6021 7.62443 13.7475 7.47611 13.8485 7.29081C13.9496 7.1055 14.0022 6.89098 13.9999 6.67262Z" fill="black"/></svg>'); 
    }else{
     $('ul#categories-cls li.nav--has-dropdown span.arrow').removeClass('active').siblings('ul').slideUp().parent('li').removeClass('liactive');
     $('ul#categories-cls li.nav--has-dropdown span.arrow').removeClass('active').siblings('ul').slideUp().parent('li').find('span').removeClass('active_subchild');
      $(this).html('<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">=<path d="M13.9999 1.32738C14.0004 1.49815 13.9675 1.66688 13.9034 1.82117C13.8394 1.97546 13.746 2.11139 13.63 2.21897L7.63053 7.73997C7.45162 7.90809 7.2272 8 6.99559 8C6.76399 8 6.53957 7.90809 6.36065 7.73997L0.361218 2.02465C0.157021 1.83063 0.0286086 1.55183 0.00423118 1.24957C-0.0201462 0.947313 0.061508 0.646366 0.231231 0.412933C0.400953 0.179501 0.644842 0.0327044 0.909243 0.00483657C1.17364 -0.0230312 1.4369 0.0703135 1.6411 0.264335L7.00059 5.37383L12.3601 0.435795C12.5069 0.296018 12.6856 0.207228 12.8751 0.179933C13.0646 0.152637 13.257 0.187977 13.4296 0.281772C13.6021 0.375567 13.7475 0.523891 13.8486 0.709193C13.9496 0.894495 14.0022 1.10902 13.9999 1.32738Z" fill="black"/></svg>')
    }
      
  });

  if (window.matchMedia("(max-width: 767px)").matches) 
        {
            
            // The viewport is less than 768 pixels wide
            console.log("This is a mobile device.");
          $('ul.products-images-main.mobile').show();
          $('ul.products-images-main.desktop').hide();
        } else {
            
            // The viewport is at least 768 pixels wide
            console.log("This is a tablet or desktop.");
                 $('ul.products-images-main.mobile').hide();
          $('ul.products-images-main.desktop').show();
        }

     $('ul.products-images-main.mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
       //variableWidth: true,
        dots: true,
        prevArrow: '<div class="slick-prev"><svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg></div>',

    });
  //product zoommer
  
// required elements
  var imgPopup = $('.img-popup');
  var imgPopup2 = $('.main_popup_wrapp');
  var imgCont  = $('.container__img-holder');
  var popupImage = $('.img-popup img');
  var closeBtn = $('.close-btn');

  // handle events
  imgCont.on('click', function() {
    var img_src = $(this).children('img').attr('src');
    imgPopup2.children('img').attr('src', img_src);
    imgPopup.addClass('opened');
  });

  $(imgPopup, closeBtn).on('click', function() {
    imgPopup.removeClass('opened');
    imgPopup2.children('img').attr('src', '');
  });

  popupImage.on('click', function(e) {
    e.stopPropagation();
  });


	
});